import { render } from "./Device.vue?vue&type=template&id=edb419e2&scoped=true&ts=true"
import script from "./Device.vue?vue&type=script&lang=ts"
export * from "./Device.vue?vue&type=script&lang=ts"

import "./Device.vue?vue&type=style&index=0&id=edb419e2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb419e2"]])

export default __exports__